import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import axios from "axios";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
  formatMoneda,
  validaMonto,
  formatoMonto,
} from "../../util/varios";
import moment from "moment";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import CatalogoInmuebles from "../../catalogos/catalogoInmuebles";

export const ActualizarRentasInmobiliarias = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const [activate, setActivate] = useState(false);
  const [msg, setMsg] = useState();
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operaciondeu, setOperaciondeu] = useState(0);
  const [desde, setDesde] = useState(0);
  const [hasta, setHasta] = useState(0);
  const [aniodesde, setAniodesde] = useState(0);
  const [aniohasta, setAniohasta] = useState(0);
  const [tecla, setTecla] = useState();
  const [activo, setActivo] = useState(true);
  const [activo1, setActivo1] = useState(false);
  const [tipoact, setTipoact] = useState(false);
  const [activo2, setActivo2] = useState(true);
  const [estado, setEstado] = useState();
  const [municipio, setMunicipio] = useState();
  const [ciudad, setCiudad] = useState();
  const [muni, setMuni] = useState();
  const [ciu, setCiu] = useState();
  const [fechanac, setFechanac] = useState();
  const [nacnalidad, setNacnalidad] = useState();
  const [body, setBody] = useState(null);
  const [select, setSelect] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [operacionPer, setOperacionPer] = useState(0);
  const [operacionage, setOperacionage] = useState(0);
  const [values, setValues] = useState({
    idrentas: "",
    idinmuebles: "",
    numcontrato: "",
    fechacontrato: "",
    idpersona: "",
    tipopersona: "",
    nombrearrendatario: "",
    direccion: "",
    cedrif: "",
    telefono: "",
    fechainicio: "",
    fechaculminacion: "",
    montoarrendamiento: 0.0,
    tipoarrendamiento: "",
    periododecancelacion: "",
    tipoloc: "",
    numeroloc: "",
    codigoimpuesto: 0,
    usoinmueble: "",
    construccion: "",
    terreno: "",
    status: 0,
  });
  const [persona, setPersona] = useState({
    cedula: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    apellidos: "",
    direccion: "",
    fnacimiento: "",
    nacionalidad: "",
    nombres: "",
    sexo: "",
  });
  const [inmueble, setInmueble] = useState({
    idinmuebles: "",
    descripcion: "",
    estado: "",
    municipio: "",
    ciudad: "",
    direccion: "",
  });
  const [agent, setagent] = useState({
    municipio: "",
    ciudad: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtIdd = useRef();
  const txtCedula = useRef();
  const txtIdage = useRef();
  const txtNombred = useRef();
  const txtDireAge = useRef();
  const txtNombre = useRef();
  const txtApellido = useRef();
  const txtDireccion = useRef();
  const txtEmail = useRef();
  const txtTlf = useRef();
  const txtCel = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const txtEmailAge = useRef();
  const txtMuniAge = useRef();
  const txtCiuAge = useRef();
  const txtNatural = useRef();
  const txtDescripInmuebles = useRef();
  const txtCodinmueble = useRef();
  const txtEstado = useRef();
  const txtMunicipio = useRef();
  const txtCiudad = useRef();
  const txtDireccioninmu = useRef();
  const txtJuridico = useRef();
  const txtEstatus = useRef();
  const txtFecha = useRef();
  const txtNacionalidad = useRef();
  const txtCedulaRif = useRef();
  const txtTelefono = useRef();
  const txtSimple = useRef();
  const txtOtros = useRef();
  const txtConstru = useRef();
  const txtTerreno = useRef();
  const txtNumcontrato = useRef();
  const txtUso = useRef();
  const txtPeriodo = useRef();
  const txtMonto = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtNumber = useRef();
  const txtTipo = useRef();

  const onChange = (event) => {
    if (event.target.name === "radio") {
      if (txtNatural.current.checked) {
        setSelect(0);
      } else if (txtJuridico.current.checked) {
        setSelect(1);
      }
      setValues({ ...values, [event.target.name]: event.target.value });
    } else if (event.target.name === "tipo") {
      if (event.target.value === "TERRENO") {
        setTipoact(true);
        txtNumber.current.value = "";
      } else {
        setTipoact(false);
      }
    } else if (event.target.name === "naci") {
      let nac = txtNacionalidad.current.value;
      setNacnalidad(nac);
    } else if (event.target.name === "desde") {
      let desd = txtDesde.current.value.substring(5, 7);
      let aniod = txtDesde.current.value.substring(0, 4);
      setDesde(desd);
      setAniodesde(aniod);
    } else if (event.target.name === "hasta") {
      let hst = txtHasta.current.value.substring(5, 7);
      let anioh = txtHasta.current.value.substring(0, 4);
      setHasta(hst);
      setAniohasta(anioh);
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
      setagent({ ...agent, [event.target.name]: event.target.value });
    }
  };

  const seleccionarEstado = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "estado";
    let nomid = "idestado";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setEstado(response.data);
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const selectMunicipio = () => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let ids = "18";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${ids}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMuni(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarCiudadAge = (id) => (e) => {
    e.preventDefault();

    if (id !== "") {
      let campos = "*";
      let nomtab = "ciudad";
      let nomid = "idmunicipio";

      let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            setCiu(response.data);
          }
        })
        .catch((error) => {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: error.response.data.message,
            icono: "error",
          });
          setActivate(false);
        });
    } else [setCiu("")];
  };

  const seleccionarMunicipio = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idmunicipio";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMunicipio(response.data);
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarMuniAge = (id) => {
    let campos = "idmunicipio, trim(nombre)  AS nombre";
    let nomtab = "municipio";
    let nomid = "idmunicipio";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idmunicipio > 0) {
            setMunicipio(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarCiudad = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idciudad";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setCiudad(response.data);
          txtCiudad.current.value = response.data.nombre;
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarCiudads = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idciudad";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setCiu(response.data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtCodinmueble.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe seleccionar el Inmueble a Arrendar",
        icono: "informacion",
      });
      sigue = false;
      txtCodinmueble.current.value = "";
      txtCodinmueble.current.focus();
    } else if (txtNacionalidad.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el tipo de Nacionalidad",
        icono: "informacion",
      });
      sigue = false;
      txtNacionalidad.current.value = "";
      txtNacionalidad.current.focus();
    } else if (txtCedulaRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Número de Documento",
        icono: "informacion",
      });
      sigue = false;
      txtCedulaRif.current.value = "";
      txtCedulaRif.current.focus();
    } else if (txtNombred.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el nombre del Arrendador",
        icono: "informacion",
      });
      sigue = false;
      txtNombred.current.value = "";
      txtNombred.current.focus();
    } else if (txtMuniAge.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Municipio",
        icono: "informacion",
      });
      sigue = false;
      txtMuniAge.current.value = "";
      txtMuniAge.current.focus();
    } else if (txtCiuAge.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione la Ciudad",
        icono: "informacion",
      });
      sigue = false;
      txtCiuAge.current.value = "";
      txtCiuAge.current.focus();
    } else if (txtDireAge.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Dirección del Arrendador",
        icono: "informacion",
      });
      sigue = false;
      txtDireAge.current.value = "";
      txtDireAge.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Campo Cédula no debe ir Vacio, Introduzca la Cédula",
        icono: "informacion",
      });
      sigue = false;
      txtCedula.current.value = "";
      txtCedula.current.focus();
    } else if (txtTipo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Seleccione el Tipo",
        icono: "informacion",
      });
      sigue = false;
      txtTipo.current.value = "";
      txtTipo.current.focus();
    } else if (txtNumcontrato.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Introducir el Número de Contrato",
        icono: "informacion",
      });
      sigue = false;
      txtNumcontrato.current.value = "";
      txtNumcontrato.current.focus();
    } else if (txtDesde.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La fecha Desde no puede ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtDesde.current.value = "";
      txtDesde.current.focus();
    } else if (txtHasta.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La fecha Hasta no puede ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtHasta.current.value = "";
      txtHasta.current.focus();
    } else if (txtPeriodo.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Periodo de Pago",
        icono: "informacion",
      });
      sigue = false;
      txtPeriodo.current.value = "";
      txtPeriodo.current.focus();
    } else if (txtMonto.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Introduzca el Monto del Arrendamiento",
        icono: "informacion",
      });
      sigue = false;
      txtMonto.current.value = "";
      txtMonto.current.focus();
    } else if (sigue) {
      var renta = [];
      var per = [];
      var agente = [];

      renta.push({
        idrentas: parseInt(txtIdd.current.value),
        idinmuebles: parseInt(txtCodinmueble.current.value),
        numcontrato: txtNumcontrato.current.value.trim(),
        fechacontrato: txtFecha.current.value,
        tipopersona: txtNatural.current.checked === true ? 0 : 1,
        fechainicio: txtDesde.current.value,
        fechaculminacion: txtHasta.current.value,
        montoarrendamiento: parseFloat(
          txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
        ),
        tipoarrendamiento: txtOtros.current.checked === true ? 0 : 1,
        periododecancelacion: txtPeriodo.current.value,
        tipoloc: txtTipo.current.value,
        numeroloc: txtNumber.current.value,
        codigoimpuesto: 3,
        usoinmueble: txtUso.current.value.trim(),
        construccion: txtConstru.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        terreno: txtTerreno.current.value
          .trim()
          .replace(/\./g, "")
          .replace(",", "."),
        status: operacion === 1 ? 0 : txtEstatus.current.value,
      });

      per.push({
        cedula: parseInt(txtCedula.current.value),
        correoe: txtEmail.current.value,
        tlf1: txtTlf.current.value,
        tlf2: txtCel.current.value,
        apellidos: txtApellido.current.value,
        direccion: txtDireccion.current.value,
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombre.current.value,
        sexo: cmbSexo.current.value,
      });

      agente.push({
        idagente:
          txtIdage.current.value !== null
            ? agent.idagente
            : parseInt(txtIdage.current.value),
        nombre: txtNombred.current.value.trim(),
        direccion: txtDireAge.current.value.trim(),
        rif: nacnalidad + txtCedulaRif.current.value,
        nrolicencia: null,
        nroresolucion: null,
        reprelegal: parseInt(txtCedula.current.value),
        telefono: txtTelefono.current.value.trim(),
        fechainscripcionrenta: txtFecha.current.value,
        statusrenta:
          operacion === 1 || txtEstatus.current.value === 0 ? 51 : 52,
        idtipoagente: 6,
        observacionstatusrenta: null,
        credito: 0.0,
        email: txtEmailAge.current.value,
        exoninteresesrenta: false,
        exonmultasrenta: false,
        exonrecargosrenta: false,
        renta: true,
        municipio: txtMuniAge.current.value.trim(),
        ciudad: txtCiuAge.current.value,
      });

      setBody({
        operacionper: operacionPer,
        operacionage: operacionage,
        agente: agente,
        renta: renta,
        per: per,
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);

    let endpoint = "";

    endpoint = `${op.conexion}/api/rentas/actualizarrentas/${parseInt(
      operacion
    )}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Creado Correctamente!",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro Modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro Eliminado correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_rif_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idrentas: "",
      idinmuebles: "",
      numcontrato: "",
      fechacontrato: "",
      idpersona: "",
      tipopersona: "",
      nombrearrendatario: "",
      direccion: "",
      cedrif: "",
      telefono: "",
      fechainicio: "",
      fechaculminacion: "",
      montoarrendamiento: 0.0,
      tipoarrendamiento: "",
      periododecancelacion: "",
      tipoloc: "",
      numeroloc: "",
      codigoimpuesto: 0,
      usoinmueble: "",
      construccion: "",
      terreno: "",
      status: "",
    });
    setPersona({
      cedula: "",
      correoe: "",
      tlf1: "",
      tlf2: "",
      apellidos: "",
      direccion: "",
      fnacimiento: "",
      nacionalidad: "",
      nombres: "",
      sexo: "",
    });
    setInmueble({
      idinmuebles: "",
      descripcion: "",
      estado: "",
      municipio: "",
      ciudad: "",
      direccion: "",
    });
    setagent({
      municipio: "",
      ciudad: "",
    });
    setEstado();
    setMunicipio();
    setCiudad();
    setSelect(0);
    setFechanac();
    setNacnalidad();
    setTipoact(false);
    setActivate(false);
    setOperaciondeu(0);
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputNombres") {
        txtApellido.current.focus();
      } else if (event.target.id === "inputApellidos") {
        txtDireccion.current.focus();
      } else if (event.target.id === "inputDireccion") {
        txtEmail.current.focus();
      } else if (event.target.id === "inputEmail") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlf.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlf.current.focus();
          }
        }
      } else if (event.target.id === "inputTlf") {
        txtCel.current.focus();
      } else if (event.target.id === "inputCel") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputEmail") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlf.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Formato de número telefonico invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlf.current.focus();
          }
        }
      } else if (event.target.id === "inputTlf") {
        txtCel.current.focus();
      } else if (event.target.id === "inputCel") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleCloseCatInmu = () => {
    setMostrar4(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombre.current.value = nomPer;
    txtApellido.current.value = apePer;
    txtDireccion.current.value = direPer;
    txtEmail.current.value = correoPer;
    txtTlf.current.value = tlf1Per;
    txtCel.current.value = tlf2Per;
    txtFechaNac.current.value = moment(fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
    btnAcepta.current.focus();
  };

  const handleAceptaInmueble = (
    idinmuebles,
    descripcion,
    estado,
    municipio,
    ciudad,
    direccion
  ) => {
    setMostrar4(false);
    txtCodinmueble.current.value = idinmuebles;
    txtDescripInmuebles.current.value = descripcion;
    txtDireccioninmu.current.value = direccion;
    btnAcepta.current.focus();
    seleccionarEstado(estado);
    seleccionarMunicipio(municipio);
    seleccionarCiudad(ciudad);
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const catalogoInmueble = (e) => {
    e.preventDefault();
    setMostrar4(true);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancelar();
    props.onHideRenderizar();
    blanquear();
  };

  const datosPer = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtNombre.current.value = "";
          txtApellido.current.value = "";
          txtDireccion.current.value = "";
          txtEmail.current.value = "";
          txtFechaNac.current.value = "";
          txtTlf.current.value = "";
          txtCel.current.value = "";
          cmbNacionalidad.current.value = "";
          cmbSexo.current.value = "";
          if (response.data !== "") {
            setOperacionPer(0);
            txtNombre.current.value =
              response.data.nombres !== null
                ? response.data.nombres.trim()
                : "";
            txtApellido.current.value =
              response.data.apellidos !== null
                ? response.data.apellidos.trim()
                : "";
            txtDireccion.current.value =
              response.data.direccion !== null
                ? response.data.direccion.trim()
                : "";
            txtEmail.current.value =
              response.data.correoe !== null
                ? response.data.correoe.trim()
                : "";
            txtCedula.current.value = response.data.cedula.trim();
            txtTlf.current.value =
              response.data.tlf1 !== null ? response.data.tlf1.trim() : "";
            txtCel.current.value =
              response.data.tlf2 !== null ? response.data.tlf2.trim() : "";
            cmbNacionalidad.current.value =
              response.data.nacionalidad !== null
                ? response.data.nacionalidad.toString()
                : "";
            cmbSexo.current.value =
              response.data.sexo !== null ? response.data.sexo.toString() : "";
            txtFechaNac.current.value =
              response.data.fnacimiento !== null
                ? moment(response.data.fnacimiento).format("YYYY-MM-DD")
                : "";
            setActivo(true);

            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            if (tecla === 13) {
              setTimeout(() => {
                cmbNacionalidad.current.focus();
                setActivo(false);
              }, 100);
            }
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosInmueble = (id) => {
    let campos = "*";
    let nomtab = "inmuebles";
    let nomid = "idinmuebles";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            txtDescripInmuebles.current.value =
              response.data.descripcion !== null
                ? response.data.descripcion.trim()
                : "";
            txtDireccioninmu.current.value =
              response.data.direccion !== null
                ? response.data.direccion.trim()
                : "";
            txtCodinmueble.current.value = response.data.idinmuebles.trim();
            seleccionarEstado(response.data.estado);
            seleccionarMunicipio(response.data.municipio);
            seleccionarCiudad(response.data.ciudad);
            setActivo2(true);

            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡Código/Inmueble no Existe!",
              icono: "informacion",
            });
            txtDescripInmuebles.current.value = "";
            txtEstado.current.value = "";
            txtMunicipio.current.value = "";
            txtCiudad.current.value = "";
            txtDireccioninmu.current.value = "";
            setEstado();
            setMunicipio();
            setCiudad();
            if (tecla === 13) {
              setTimeout(() => {
                txtCodinmueble.current.focus();
              }, 100);
            }
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosAge = (id) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "rif";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          txtIdage.current.value = "";
          txtNombred.current.value = "";
          txtDireAge.current.value = "";
          txtTelefono.current.value = "";
          txtMuniAge.current.value = "";
          txtCiuAge.current.value = "";
          txtEmailAge.current.value = "";
          if (response.data !== "") {
            setOperacionage(0);
            txtIdage.current.value = response.data.idagente;
            txtNombred.current.value = response.data.nombre;
            txtDireAge.current.value = response.data.direccion;
            txtTelefono.current.value = response.data.telefono;
            txtEmailAge.current.value = response.data.email.trim();
            seleccionarCiudads(response.data.ciudad);
            selectMunicipio(response.data.municipio);

            setagent(response.data);

            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionage(1);
            selectMunicipio();
            setCiu();
            setMuni();
            setagent();
            txtNombred.current.focus();
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarPersona = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosPer(event.target.value);
      } else {
        txtNombre.current.value = "";
      }
    }
  };

  const validarInmueble = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosInmueble(event.target.value);
      } else {
        txtNombre.current.value = "";
      }
    }
  };

  const validarAgente = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        if (txtNacionalidad.current.value !== "") {
          datosAge(nacnalidad + event.target.value);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Tipo de Nacionalidad",
            icono: "informacion",
          });
          txtNacionalidad.current.focus();
        }
      } else {
        txtNombre.current.value = "";
      }
    }
  };

  useEffect(() => {
    let anio = fechaSistema.substring(0, 4);
    let mes = fechaSistema.substring(5, 7);
    let dia = fechaSistema.substring(8, 10);
    let fechanaci;
    fechanaci = anio - 18;
    setFechanac(fechanaci + "-" + mes + "-" + dia);
  }, []);

  const CrearDeuda = () => {
    let endpoint = `${op.conexion}/api/rentas/creardeuda/${operaciondeu}`;
    let body;
    setActivate(true);

    body = {
      tipodecla: parseInt(1),
      mesini: parseInt(desde),
      mesfin: parseInt(hasta),
      monto: parseFloat(
        txtMonto.current.value.trim().replace(/\./g, "").replace(",", ".")
      ),
      tipodeu: parseInt(17),
      idagente: parseInt(txtIdage.current.value),
      anioini: parseInt(aniodesde),
      aniofin: parseInt(aniohasta),
      fecha: moment(fechaSistema).format("YYYY-MM-DD"),
      status: parseInt(0),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Deuda Cargada Correctamente",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            "llave duplicada viola restricción de unicidad «fk_deuda_unique»"
          ) {
            mensaje =
              "¡Ya fuerón Cargadas las Deudas para los Periodos Seleccionados!";
            setOperaciondeu(0);
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarDeuda = (op) => (e) => {
    let msg = "";
    msg = "Esta Seguro de Cargar esta Deuda?.";
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: msg,
      icono: "confirmacion",
    });
    setOperaciondeu(op);
  };

  const handleCloseSi = () => {
    if (operaciondeu === 7) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      CrearDeuda();
    } else {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      procesarRegistro();
    }
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onNext = (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.name === "contru") {
        txtTerreno.current.focus();
      } else if (event.target.name === "terreno") {
        txtTipo.current.focus();
      } else if (event.target.name === "tipo") {
        txtNumber.current.focus();
      } else if (event.target.name === "numberl") {
        txtUso.current.focus();
      } else if (event.target.name === "uso") {
        txtNumcontrato.current.focus();
      } else if (event.target.name === "contrato") {
        txtDesde.current.focus();
      } else if (event.target.name === "periodo") {
        txtMonto.current.focus();
      }
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        setOperacionage(props.operacion);
        selectMunicipio();

        if (props.operacion !== 1) {
          setPersona(props.persona);
          setValues(props.rentas);
          setInmueble(props.inmueble);
          setagent(props.agente);
          setNacnalidad(props.agente.rif.substring(0, 1));
          setCiu(props.ciu);
          setEstado(props.estado);
          setMunicipio(props.municipio);
          setOperacionPer(props.operacion);

          let id = props.idciu;
          seleccionarCiudads(id);

          let d = props.rentas.fechainicio.substring(5, 7);
          let h = props.rentas.fechaculminacion.substring(5, 7);
          let ad = props.rentas.fechainicio.substring(0, 4);
          let ah = props.rentas.fechaculminacion.substring(0, 4);
          setDesde(d);
          setHasta(h);
          setAniodesde(ad);
          setAniohasta(ah);

          if (props.rentas.tipopersona === 0) {
            txtNatural.current.checked = true;
            txtJuridico.current.checked = false;
            setSelect(0);
          } else if (props.rentas.tipopersona === 1) {
            txtNatural.current.checked = false;
            txtJuridico.current.checked = true;
            setSelect(1);
          }

          if (props.rentas.tipoarrendamiento === 0) {
            txtOtros.current.checked = true;
            txtSimple.current.checked = false;
          } else if (props.rentas.tipoarrendamiento === 1) {
            txtOtros.current.checked = false;
            txtSimple.current.checked = true;
          }
        } else {
          blanquear();
          setCiu();
          cmbNacionalidad.current.value = "";
          cmbSexo.current.value = "";
          txtFechaNac.current.value = "";
          txtNacionalidad.current.value = "";
          txtCedulaRif.current.value = "";
          txtTipo.current.value = "";
          txtPeriodo.current.value = "1";
          txtEstatus.current.value = 0;
          txtNombred.current.value = "";
          txtTelefono.current.value = "";
          txtDireAge.current.value = "";
          txtEmailAge.current.value = "";
          txtMonto.current.value = "";
          txtCiudad.current.value = "";
          txtFecha.current.value = moment(fechaSistema).format("YYYY-MM-DD");
          txtDesde.current.value = moment(fechaSistema).format("YYYY-MM-DD");
          txtHasta.current.value = moment(fechaSistema).format("YYYY-MM-DD");
          if (txtNatural.current.checked === true) {
            setSelect(0);
          } else if (txtJuridico.current.checked === true) {
            setSelect(1);
          }
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Registro de Renta Inmobiliaria por Contribuyente."
              : operacion === 2
              ? "Editar Renta Inmobiliaria por Contribuyente."
              : operacion === 3
              ? "Eliminar Renta Inmobiliaria por Contribuyente."
              : "Consultar Renta Inmobiliaria por Contribuyente."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <CatalogoPersona
          mensaje={msg}
          show={mostrar3}
          onHideCancelaCatPer={handleCloseCatalogoPer}
          onHideAceptaCatPer={handleAceptaCatalogoPer}
        />
        <CatalogoInmuebles
          mensaje={msg}
          show={mostrar4}
          onHideAceptaInmu={handleAceptaInmueble}
          onHideCancelaInmu={handleCloseCatInmu}
        />
        <Dimmer active={activate} />
        <div className="container-fluid rounded">
          <div className="tab-content" id="ex-with-icons-content">
            <div
              className="tab-pane fade show active"
              id="tab-1"
              role="tabpanel"
              aria-labelledby="ex-with-icons-tab-1"
            >
              <div className="container row m-0">
                <div className="input-group input-group-sm col-sm-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Código:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    disabled={true}
                    ref={txtIdd}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={values ? values.idrentas.trim() : ""}
                    id="inputCedula"
                  />
                </div>
                <div className="input-group input-group-sm col-sm-2 ml-auto">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Estatus:
                  </label>
                  <select
                    disabled={
                      operacion === 4 || operacion === 1 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    defaultValue={props.rentas ? props.rentas.status : ""}
                    ref={txtEstatus}
                    className="form-select form-control-sm"
                  >
                    <option key="0" value="0">
                      ACTIVO
                    </option>
                    <option key="1" value="1">
                      INACTIVO
                    </option>
                  </select>
                </div>
                <div className="input-group input-group-sm col-sm-2 px-1 ml-auto">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Fecha:
                  </label>
                  <input
                    type="date"
                    className="form-control text-uppercase"
                    autoComplete="off"
                    max={moment(fechaSistema).format("YYYY-MM-DD")}
                    defaultValue={
                      props.rentas
                        ? moment(props.rentas.fechacontrato).format(
                            "YYYY-MM-DD"
                          )
                        : moment(fechaSistema).format("YYYY-MM-DD")
                    }
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    ref={txtFecha}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
                <div className="col-md-3 row m-0 ml-auto">
                  <div className="form-check col-sm-6">
                    <input
                      className="form-check-input"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="radio"
                      value="1"
                      ref={txtNatural}
                      onChange={onChange}
                      id="radioSi"
                      type="radio"
                    />
                    <label className="form-check-label" for="exampleRadi4">
                      Natural
                    </label>
                  </div>
                  <div className="form-check col-sm-6">
                    <input
                      className="form-check-input"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="radio"
                      value="2"
                      ref={txtJuridico}
                      onChange={onChange}
                      id="radioNo"
                      defaultChecked={true}
                      type="radio"
                    />
                    <label className="form-check-label" for="exampleRadi5">
                      Juridico
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul mx-auto rounded">
                <legend className="float-none m-0 w-auto">
                  Datos del Inmueble:
                </legend>

                <div className="input-group input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    <i className="fas fa-qrcode fa-lg px-1"></i>Código del
                    Inmueble:
                  </label>
                  <input
                    type="text"
                    disabled={
                      operacion === 4 || operacion === 3 ? true : activo1
                    }
                    maxLength="9"
                    autoComplete="off"
                    ref={txtCodinmueble}
                    onKeyUp={validarInmueble}
                    onBlur={validarInmueble}
                    className="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    id="inputCedula"
                    defaultValue={
                      inmueble && inmueble.idinmuebles !== null
                        ? inmueble.idinmuebles
                        : ""
                    }
                  />
                  <button
                    disabled={
                      operacion === 4 || operacion === 3 ? true : deshabilitado
                    }
                    onClick={catalogoInmueble}
                    className="btn btn-sm  btn-info"
                  >
                    <i className="fa fa-search"></i>{" "}
                  </button>
                </div>

                <div className="input-group input-group-sm col-sm-6">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Descripción:
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    autoComplete="off"
                    disabled={activo2}
                    ref={txtDescripInmuebles}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={
                      inmueble && inmueble.descripcion !== null
                        ? inmueble.descripcion.trim()
                        : ""
                    }
                    id="inputCedula"
                  />
                </div>

                <div className="input-group input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Estado:
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    autoComplete="off"
                    disabled={activo2}
                    ref={txtEstado}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={estado ? estado.nombre.trim() : ""}
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Municipio:
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    autoComplete="off"
                    disabled={activo2}
                    ref={txtMunicipio}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    value={municipio ? municipio.nombre.trim() : ""}
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-3">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Ciudad:
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    autoComplete="off"
                    disabled={activo2}
                    ref={txtCiudad}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={
                      props.ciudad ? props.ciudad.nombre.trim() : ""
                    }
                  />
                </div>

                <div className="input-group py-1 input-group-sm col-sm-6">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Dirección:
                  </label>
                  <input
                    type="text"
                    className="form-control text-uppercase"
                    autoComplete="off"
                    disabled={activo2}
                    ref={txtDireccioninmu}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={
                      inmueble && inmueble.direccion !== null
                        ? inmueble.direccion.trim()
                        : ""
                    }
                    id="inputCedula"
                  />
                </div>
              </fieldset>

              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">
                  Datos del Arrendatario
                </legend>
                <input
                  type="hidden"
                  className="form-control px-1"
                  autoComplete="off"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  ref={txtIdage}
                  defaultValue={
                    props.agente && props.agente.idagente
                      ? props.agente.idagente
                      : ""
                  }
                />
                <div className="col-sm-2 px-0">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm px-1"
                    >
                      {select === 1 ? "RIF" : "Cédula"}:
                    </label>

                    {select === 1 ? (
                      <select
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={txtNacionalidad}
                        name="naci"
                        onChange={onChange}
                        value={nacnalidad}
                        className="col-sm-3 px-1 form-select form-control-sm"
                      >
                        <option value="">-</option>
                        <option key="0" value="V">
                          V
                        </option>
                        <option key="1" value="J">
                          J
                        </option>
                        <option key="2" value="G">
                          G
                        </option>
                        <option key="3" value="P">
                          P
                        </option>
                      </select>
                    ) : (
                      <select
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={txtNacionalidad}
                        name="naci"
                        onChange={onChange}
                        value={nacnalidad}
                        className="col-sm-3 px-1 form-select form-control-sm"
                      >
                        <option value="">-</option>
                        <option key="0" value="V">
                          V
                        </option>
                        <option key="1" value="E">
                          E
                        </option>
                      </select>
                    )}
                    <input
                      type="text"
                      className="form-control px-1"
                      onKeyUp={validarAgente}
                      onBlur={validarAgente}
                      autoComplete="off"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtCedulaRif}
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      maxLength="9"
                      defaultValue={
                        props.agente && props.agente.rif
                          ? props.agente.rif.substring(1, 10)
                          : ""
                      }
                      id="rif"
                      name="rif"
                    />
                  </div>
                </div>

                <div className="col-sm-8">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {select === 1 ? "Razón Social" : "Apellidos y Nombres"}:
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      autoComplete="off"
                      ref={txtNombred}
                      defaultValue={
                        props.agente ? props.agente.nombre.trim() : ""
                      }
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                </div>

                <div className="col-sm-2 px-0">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Telefono:
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      maxLength="11"
                      autoComplete="off"
                      ref={txtTelefono}
                      defaultValue={
                        props.agente ? props.agente.telefono.trim() : ""
                      }
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputEmailUsuario"
                    />
                  </div>
                </div>

                <div className="col-sm-4 py-1 px-0">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Correo:
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      autoComplete="off"
                      ref={txtEmailAge}
                      defaultValue={
                        props.agente ? props.agente.email.trim() : ""
                      }
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>

                <div className="col-sm-4 py-1 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Municipio:
                    </label>
                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtMuniAge}
                      className="form-select text-center"
                      id="inputStatus"
                      name="municipio"
                      onChange={onChange}
                      value={agent ? agent.municipio : ""}
                    >
                      <option value="" onClick={seleccionarCiudadAge("")}>
                        ---------------------Seleccione---------------------
                      </option>
                      {muni &&
                        muni.map((item, index) => (
                          <option
                            key={index}
                            value={item.idmunicipio}
                            onClick={seleccionarCiudadAge(item.idmunicipio)}
                          >
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-sm-3 px-0 py-1 ml-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text px-1"
                      id="inputGroup-sizing-sm"
                    >
                      Ciudad:
                    </label>
                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtCiuAge}
                      className="form-select text-center"
                      id="inputStatus"
                      name="ciudad"
                      onChange={onChange}
                      value={agent ? agent.ciudad : ""}
                    >
                      <option value="">
                        --------------Seleccione--------------
                      </option>
                      {ciu &&
                        ciu.map((item, index) => (
                          <option key={index} value={item.idciudad}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="col-sm-12 px-0">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Dirección:
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      autoComplete="off"
                      ref={txtDireAge}
                      defaultValue={
                        props.agente ? props.agente.direccion.trim() : ""
                      }
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </fieldset>

              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">
                  Datos del Responsable
                </legend>

                <div className="container row m-0 px-0">
                  <div className="input-group input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      <i className="far fa-lg px-1 fa-id-card"></i>Cedula:
                    </label>
                    <select
                      className="form-select col-3"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      ref={cmbNacionalidad}
                      aria-label="Default select example "
                      defaultValue={
                        props.persona && props.persona.nacionalidad !== null
                          ? props.persona.nacionalidad.trim()
                          : ""
                      }
                      id="inputNac"
                    >
                      <option value="V">V</option>
                      <option value="J">J</option>
                      <option value="E">E</option>
                    </select>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      maxLength="9"
                      autoComplete="off"
                      ref={txtCedula}
                      onKeyUp={validarPersona}
                      onBlur={validarPersona}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputCedula"
                      defaultValue={
                        persona && persona.cedula !== null ? persona.cedula : ""
                      }
                    />
                    <button
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onClick={catalogoPer}
                      className="btn btn-sm  btn-info"
                    >
                      <i className="fa fa-search"></i>{" "}
                    </button>
                  </div>
                  <div className="input-group input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombres:
                    </label>
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      autoComplete="off"
                      ref={txtNombre}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        persona && persona.nombres !== null
                          ? persona.nombres.trim()
                          : ""
                      }
                      id="inputNombres"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="input-group input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Apellidos:
                    </label>
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      autoComplete="off"
                      ref={txtApellido}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        persona && persona.apellidos !== null
                          ? persona.apellidos.trim()
                          : ""
                      }
                      id="inputApellidos"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="input-group input-group-sm col-sm-1">
                    <label
                      className="input-group-text col-5 px-1"
                      id="inputGroup-sizing-sm"
                    >
                      Sexo:
                    </label>
                    <select
                      className="form-select px-0"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      ref={cmbSexo}
                      aria-label="Default select example "
                      defaultValue={
                        props.persona ? props.persona.sexo.trim() : ""
                      }
                      id="inputSexo"
                    >
                      <option key="0" value="M">
                        M
                      </option>
                      <option key="1" value="F">
                        F
                      </option>
                    </select>
                  </div>
                </div>

                <div className="container row m-0 px-0">
                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Direccion:
                    </label>
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      autoComplete="off"
                      ref={txtDireccion}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        persona && persona.direccion !== null
                          ? persona.direccion.trim()
                          : ""
                      }
                      id="inputDireccion"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </div>
                <div className="container row m-0 px-0">
                  <div className="input-group input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Fecha Nacimiento:
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      ref={txtFechaNac}
                      max={moment(fechanac).format("YYYY-MM-DD")}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        props.persona
                          ? moment(props.persona.fnacimiento).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      id="inputFnac"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="input-group input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      E-mail:
                    </label>
                    <input
                      type="text"
                      className="form-control text-uppercase"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      autoComplete="off"
                      ref={txtEmail}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        persona && persona.correoe !== null
                          ? persona.correoe
                          : ""
                      }
                      id="inputEmail"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="input-group input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Telefono:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      ref={txtTlf}
                      maxLength="11"
                      autoComplete="off"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        persona && persona.tlf1 !== null ? persona.tlf1 : ""
                      }
                      id="inputTlf"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Celular:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      disabled={
                        operacion === 4 || operacion === 3 ? true : activo1
                      }
                      ref={txtCel}
                      maxLength="11"
                      autoComplete="off"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      defaultValue={
                        persona && persona.tlf2 !== null ? persona.tlf2 : ""
                      }
                      id="inputCel"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </div>
              </fieldset>

              <div className="col-md-12 py-1"></div>

              <fieldset className="row border-azul rounded mx-auto">
                <legend className="float-none m-0 w-auto">
                  Datos de la Contratación
                </legend>

                <div className="col-md-3">
                  <fieldset className="row border-azul rounded col-md-12">
                    <legend className="float-none m-0 w-auto fs-6">
                      Tipo de Arrendamiento:
                    </legend>

                    <div className="col-12 row m-0">
                      <div className="form-check col-sm-5 ml-auto">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 4 || operacion === 3
                              ? true
                              : deshabilitado
                          }
                          name="radiosimc"
                          ref={txtSimple}
                          id="radisimc1"
                          defaultChecked={true}
                          type="radio"
                        />
                        <label className="form-check-label" for="radisimc1">
                          Simple
                        </label>
                      </div>
                      <div className="form-check col-sm-4 ml-auto">
                        <input
                          className="form-check-input"
                          disabled={
                            operacion === 4 || operacion === 3
                              ? true
                              : deshabilitado
                          }
                          name="radiosimc"
                          ref={txtOtros}
                          id="radisimc2"
                          type="radio"
                        />
                        <label className="form-check-label" for="radisimc2">
                          Otros
                        </label>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-md-9 row m-0">
                  <div className="input-group input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Área/Construcción(m<sup>2</sup>):
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      autoComplete="off"
                      placeholder="0,00"
                      ref={txtConstru}
                      name="contru"
                      defaultValue={values ? values.construccion : ""}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUpCapture={handleInputMontoChange}
                      onKeyUp={onNext}
                      onBlur={handleInputMontoChange}
                    />
                  </div>
                  <div className="input-group input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Área del Terreno(m<sup>2</sup>):
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      autoComplete="off"
                      placeholder="0,00"
                      ref={txtTerreno}
                      name="terreno"
                      defaultValue={values ? values.terreno : ""}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUpCapture={handleInputMontoChange}
                      onKeyUp={onNext}
                      onBlur={handleInputMontoChange}
                    />
                  </div>
                  <div className="col-md-4 row m-0 px-0">
                    <div className="input-group input-group-sm col-7">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        Tipo:
                      </label>
                      <select
                        disabled={
                          operacion === 4 || operacion === 3
                            ? true
                            : deshabilitado
                        }
                        ref={txtTipo}
                        name="tipo"
                        onChange={onChange}
                        onChangeCapture={onNext}
                        defaultValue={
                          props.rentas ? props.rentas.tipoloc.trim() : ""
                        }
                        className="form-select form-control-sm px-1"
                      >
                        <option value="">-Seleccione-</option>
                        <option key="0" value="LOCAL">
                          LOCAL
                        </option>
                        <option key="1" value="OFICINA">
                          OFICINA
                        </option>
                        <option key="2" value="PUESTO">
                          PUESTO
                        </option>
                        <option key="3" value="TERRENO">
                          TERRENO
                        </option>
                      </select>
                    </div>
                    <div className="input-group input-group-sm col">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        N°:
                      </label>
                      <input
                        type="text"
                        disabled={
                          operacion === 4 || operacion === 3 || tipoact === true
                            ? true
                            : deshabilitado
                        }
                        autoComplete="off"
                        ref={txtNumber}
                        name="numberl"
                        onKeyUp={onNext}
                        defaultValue={
                          values && values.numeroloc !== null
                            ? values.numeroloc.trim()
                            : ""
                        }
                        className="form-control"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        id="inputLogin"
                      />
                    </div>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Usu del Inmueble:
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      autoComplete="off"
                      ref={txtUso}
                      name="uso"
                      onKeyUp={onNext}
                      defaultValue={
                        values && values.usoinmueble !== null
                          ? values.usoinmueble.trim()
                          : ""
                      }
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>
                </div>

                <div className="col-md-12 row m-0">
                  <div className="input-group py-1 input-group-sm col-sm-2 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      N° Contrato:
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      autoComplete="off"
                      ref={txtNumcontrato}
                      name="contrato"
                      onKeyUp={onNext}
                      defaultValue={
                        values && values.numcontrato !== null
                          ? values.numcontrato.trim()
                          : ""
                      }
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-2 px-0">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Desde:
                    </label>
                    <input
                      type="date"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onChangeCapture={onChange}
                      name="desde"
                      onChange={onNext}
                      autoComplete="off"
                      ref={txtDesde}
                      defaultValue={
                        props.rentas
                          ? moment(props.rentas.fechainicio).format(
                              "YYYY-MM-DD"
                            )
                          : moment(fechaSistema).format("YYYY-MM-DD")
                      }
                      className="form-control text-center"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputLogin"
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-2 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Hasta:
                    </label>
                    <input
                      type="date"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      onChangeCapture={onChange}
                      name="hasta"
                      onChange={onNext}
                      autoComplete="off"
                      ref={txtHasta}
                      defaultValue={
                        props.rentas
                          ? moment(props.rentas.fechaculminacion).format(
                              "YYYY-MM-DD"
                            )
                          : moment(fechaSistema).format("YYYY-MM-DD")
                      }
                      className="form-control text-center px-1"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputEmailUsuario"
                    />
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-3 px-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Periodo de Cancelación:
                    </label>
                    <select
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      ref={txtPeriodo}
                      name="periodo"
                      onChange={onChange}
                      onChangeCapture={onNext}
                      defaultValue={
                        props.rentas &&
                        props.rentas.periododecancelacion !== null
                          ? props.rentas.periododecancelacion
                          : ""
                      }
                      className="form-select form-control-sm"
                    >
                      <option key="0" value="1">
                        Mensual
                      </option>
                      <option key="1" value="2">
                        Trimestral
                      </option>
                      <option key="2" value="3">
                        Anual
                      </option>
                    </select>
                  </div>

                  <div className="input-group py-1 input-group-sm col-sm-3 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Monto Arrendamiento:
                    </label>
                    <input
                      type="text"
                      disabled={
                        operacion === 4 || operacion === 3
                          ? true
                          : deshabilitado
                      }
                      name="monto"
                      placeholder="0,00"
                      onKeyUp={handleInputMontoChange}
                      onBlur={handleInputMontoChange}
                      autoComplete="off"
                      ref={txtMonto}
                      defaultValue={
                        props.rentas && props.rentas.montoarrendamiento
                          ? formatMoneda(
                              props.rentas.montoarrendamiento
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )
                          : ""
                      }
                      className="form-control text-right"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  {operacion === 2 || operacion === 7 ? (
                    <div className="col-2 ml-auto">
                      <div className="col-11 ml-auto">
                        <button
                          type="button"
                          onClick={procesarDeuda(7)}
                          disabled={operacion === 4 ? true : false}
                          className="btn btn-primary btn-sm rounded-pill"
                        >
                          <i className="fas fa-spinner"></i> Cargar Deuda
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
          className="btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i> Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i> Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/rentas/modalActualizarRentas.js